import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import usePlan from '../hooks/usePlan';

function AdminRoute({ children }) {
  const { user } = useAuth();
  const { plan } = usePlan();
  if (!user) return <Navigate to="/login" replace />;
  if (plan.id !== 'admin') return <Navigate to="/" replace />;
  return children;
}

export default AdminRoute;
